import { render, staticRenderFns } from "./MessageWidget.vue?vue&type=template&id=796fbeea"
import script from "./MessageWidget.vue?vue&type=script&lang=js"
export * from "./MessageWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports